const headerFunc = (header) => {
  // const header = document.querySelector('.header');

  if (window.pageYOffset > 20) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
}

export default headerFunc;